import "core-js/modules/es.array.concat";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Bus from '@/util/eventBus';
import IconArrow from '@vip-activity/ui/components/icon/IconArrow.vue';
import HuoMask from '../HuoMask/HuoMask.vue';
var _window = window,
    VftSingleCashier = _window.VftSingleCashier;
export default {
  components: {
    IconArrow: IconArrow,
    HuoMask: HuoMask
  },
  data: function data() {
    return {
      maskShow: false,
      show: false,
      num: 4,
      buyForMe: true,
      buyForOhter: false
    };
  },
  computed: {
    allNum: function allNum() {
      var num = 0;

      if (this.buyForMe) {
        num += 1;
      }

      if (this.buyForOhter) {
        num += this.num;
      }

      return num;
    },
    hasBook: function hasBook() {
      return this.$store.state.hasBook;
    },
    curPrice: function curPrice() {
      if (this.isVip) {
        return this.vipPrice;
      }

      return this.nvipPrice;
    },
    unitPrice: function unitPrice() {
      if (this.allNum >= 101) {
        return 8;
      }

      if (this.allNum >= 5) {
        return 12;
      }

      return 18;
    },
    vipPrice: function vipPrice() {
      return this.allNum * this.unitPrice;
    },
    nvipPrice: function nvipPrice() {
      return this.allNum * 40;
    },
    saveMoney: function saveMoney() {
      return this.nvipPrice - this.vipPrice;
    },
    buyTip: function buyTip() {
      if (this.allNum >= 5) {
        return "\u5DF2\u4EAB".concat(this.unitPrice, "\u5143/\u4EFD\u4F18\u60E0\u4EF7");
      }

      var num = 5;

      if (this.buyForMe) {
        num = 4;
      }

      return "\u4E70".concat(num, "\u4EFD\u4EAB12\u5143/\u4EFD\u4F18\u60E0\u4EF7");
    },
    toastTexts: function toastTexts() {
      return window.setting.支付面板.引导文案;
    },
    maxNum: function maxNum() {
      return 300;
    },
    isVip: function isVip() {
      return this.vipService.isVip;
    }
  },
  methods: {
    toggleBuyForMe: function toggleBuyForMe() {
      if (this.hasTicket) {
        return;
      }

      this.buyForMe = !this.buyForMe;
    },
    validate: function validate(nextNum) {
      if (nextNum < 1) {
        return -1;
      }

      if (nextNum > this.maxNum) {
        return -2;
      }

      return 1;
    },
    setInputVal: function setInputVal(val) {
      var result = this.validate(val);

      if (result === -1) {
        this.toast(this.toastTexts.超下限);
        this.num = 1;
        this.$refs.input.value = 1;
      } else if (result === -2) {
        this.toast(this.toastTexts.超上限);
        this.num = this.maxNum;
        this.$refs.input.value = this.maxNum;
      } else {
        this.num = val;
      }
    },
    sub: function sub() {
      var num = +this.num;
      this.setInputVal(num - 1);

      if (!this.buyForOhter) {
        this.buyForOhter = true;
      }
    },
    add: function add() {
      var num = +this.num;
      this.setInputVal(num + 1);

      if (!this.buyForOhter) {
        this.buyForOhter = true;
      }
    },
    checkNumOninput: function checkNumOninput(e) {
      var val = +e.target.value;
      this.setInputVal(val);
    },
    checkNumOnchange: function checkNumOnchange(e) {
      var val = +e.target.value;
      this.setInputVal(val);
    },
    getBuyParams: function getBuyParams() {
      var params = {
        appid: '1005',
        // 必填
        items: "".concat(this.isLiveEnd ? 'rocket_girl_dianbo' : 'rocket_girl', ":").concat(this.allNum),
        // 必填
        remark: '',
        // 必填
        hlwofferid: '457304'
      };

      if (this.buyForMe) {
        params.remark = 'buyForYourself:1';
      }

      return params;
    },
    buy: function buy() {
      if (this.allNum < 1) {
        this.toast('请先选择购买数量');
        return;
      }

      var self = this; // todo 拉起支付组件

      VftSingleCashier.buy(_objectSpread(_objectSpread({}, this.getBuyParams()), {}, {
        onSuccess: function onSuccess(res) {
          console.log('pay succ, orderid:', res.order_id);
          Bus.$emit('buyTicketSuccess');
          self.paySuccCb(res);
        },
        onCancel: function onCancel() {
          console.log('user canceled...');
        }
      }));
    },
    close: function close() {
      var _this = this;

      this.show = false;
      setTimeout(function () {
        _this.maskShow = false;
      }, 1000);
    },
    launchShare: function launchShare(data) {
      Bus.$emit('launchShare', data);
    },
    bindEvent: function bindEvent() {
      var _this2 = this;

      Bus.$on('showBuyPanel', function () {
        _this2.maskShow = true;
        setTimeout(function () {
          _this2.show = true;
        }, 100);
      });
    },
    setTicket: function setTicket() {
      // 已有观看资格
      if (this.hasTicket) {
        // 是vip
        if (this.isVip) {
          this.num = 5;
        } else {
          this.num = 1;
        }

        this.buyForMe = false;
        this.buyForOhter = true;
      } else {
        if (this.isVip) {
          this.num = 4;
        } else {
          this.num = 1;
        }

        this.buyForMe = true;
        this.buyForOhter = false;
      }
    },
    paySuccCb: function paySuccCb(res) {
      // todo 拉起分享图
      if (this.buyForOhter) {
        this.launchShare({
          type: 1,
          orderid: res.order_id,
          num: this.num,
          allNum: this.allNum,
          sendDesc: '送出'
        });
      } else {
        this.launchShare({
          type: 0,
          orderid: res.order_id,
          num: this.selfTicketCount + this.allNum,
          sendDesc: '已支持'
        });
      } // 关闭当前的支付弹窗


      this.close();

      if (this.buyForMe) {
        Bus.$emit('refreshTicketInfo');
      } else {
        this.$store.dispatch('getBuyList');
      }
    }
  },
  watch: {
    hasTicket: function hasTicket() {
      this.setTicket();
    },
    isVip: function isVip() {
      this.setTicket();
    },
    show: function show() {
      if (this.show) {
        this.setTicket();
      }
    }
  },
  mounted: function mounted() {
    this.bindEvent(); // eslint-disable-next-line no-underscore-dangle
    // window._test = () => this.paySuccCb({
    //   order_id: '115896458128916481',
    // })
  }
};